import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { AparenciaSync } from './componentes/aparencia-sync';
import './estilos.css';

const cliente = new QueryClient({
  defaultOptions: {
    queries: {
      // Cadastro societário não muda sozinho: refetch ao focar a janela só
      // gasta rede. O que muda, muda por ação do próprio usuário — e aí a
      // mutação invalida a query.
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      retry: 1,
    },
  },
});

const raiz = document.getElementById('raiz');
if (!raiz) throw new Error('elemento #raiz não encontrado');

createRoot(raiz).render(
  <StrictMode>
    <QueryClientProvider client={cliente}>
      <AparenciaSync />
      {/* `/app` é o caminho do SPA no domínio único — ver `vite.config.ts`
          (`base`) e `apps/web/nginx.conf`. Sem `basename`, o React Router não
          reconhece `/app/sociedades` como a rota `/sociedades`. */}
      <BrowserRouter basename="/app">
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
